/**
 * Firebase initialisation for Viveka.
 *
 * Used primarily for Firebase Storage (file attachments on coaching
 * sessions).  The configuration values are read from REACT_APP_FIREBASE_*
 * environment variables so each environment (demo / staging / production)
 * can point at a different Firebase project or bucket.
 *
 * If the env vars are missing the module exports `null` for both `app` and
 * `storage` so callers can fall back gracefully.
 */
import firebase from 'firebase/compat/app';
import 'firebase/compat/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

let app = null;
let storage = null;

// Only initialise if the minimum required config is present.
if (firebaseConfig.apiKey && firebaseConfig.storageBucket) {
  try {
    // Avoid double-init if hot-reloaded during development.
    app = firebase.apps.length ? firebase.app() : firebase.initializeApp(firebaseConfig);
    storage = firebase.storage(app);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('[Firebase] initialisation failed:', err);
  }
}

export { app, storage };
export default firebase;
